import { motion } from 'framer-motion';
import { FileCheck, Users, Handshake, Shield, Award, Clock } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const differentiators = [
  {
    icon: <FileCheck className="w-8 h-8" />,
    title: 'D2D Model',
    description: 'Our Documentation to Disbursement approach ensures complete end-to-end support, eliminating gaps and ensuring seamless execution.'
  },
  {
    icon: <Users className="w-8 h-8" />,
    title: 'Expert Team',
    description: 'Led by qualified Chartered Accountants with combined experience of over 30 years in finance, banking, and government schemes.'
  },
  {
    icon: <Handshake className="w-8 h-8" />,
    title: 'Strong Relationships',
    description: 'Established partnerships with major banks, NBFCs, and government bodies ensure faster processing and better terms.'
  },
  {
    icon: <Shield className="w-8 h-8" />,
    title: 'Transparent Approach',
    description: 'Clear fee structures, honest assessments, and regular updates throughout the process. No hidden charges, no surprises.'
  },
  {
    icon: <Award className="w-8 h-8" />,
    title: '98% Success Rate',
    description: 'Our meticulous approach and deep expertise result in exceptionally high approval rates for subsidies and loans.'
  },
  {
    icon: <Clock className="w-8 h-8" />,
    title: 'Timely Delivery',
    description: 'Efficient processes and proactive follow-ups ensure your applications are processed within optimal timelines.'
  }
];

export const WhyUsDifferentiators = () => (
  <section className="py-24" data-testid="differentiators-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          What Sets Us Apart
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          Our unique approach and commitment to excellence make us the preferred choice for financial consultancy.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {differentiators.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <Card className="h-full service-card border border-slate-100 hover:border-[#00bcd4]/30 bg-white">
              <CardContent className="p-8">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#3b5998] to-[#00bcd4] flex items-center justify-center text-white mb-6">
                  {item.icon}
                </div>
                <h3 className="font-heading text-xl font-semibold text-[#0f172a] mb-3">
                  {item.title}
                </h3>
                <p className="text-[#64748b] text-sm leading-relaxed">
                  {item.description}
                </p>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
